import { AnimatePresence, motion } from 'framer-motion'

import { TriggerListCard, TriggerListCardSkeleton } from '@apps-common/apps/portal/pages/units/pages/manage/pages/triggers/components'
import { NoResultsAddCard } from '@apps-common/components/common'
import { ProductNotSupportedCard } from '@apps-common/components/common/ProductNotSupportedCard'
import { motionFadeIn } from '@apps-common/config/motion-variants'
import { CONTROL_TRIGGER_SCHEDULE_ALLOWED_PRODUCTS } from '@apps-common/config/product-codes'
import { UNIT_STATUS_CANCELLED } from '@apps-common/config/unit-filter'
import { IUnitTriggerModel } from '@apps-common/types/portal/unit-trigger'
import { useTriggerModifyModal } from '../hooks/useTriggerModifyModal'

interface IProps {
  status: string
  unitId: string
  productId: string
  loading: boolean
  data: IUnitTriggerModel[]
}

export const Triggers: React.FC<IProps> = ({ status, unitId, productId, loading, data }) => {
  const { present } = useTriggerModifyModal({
    status,
    unitId,
    productId,
    triggerId: undefined
  })

  return (
    <ProductNotSupportedCard
      bgClasses='bg-surface text-text border border-border'
      productId={productId}
      message='This product does not support triggers.'
      allowedProductIds={CONTROL_TRIGGER_SCHEDULE_ALLOWED_PRODUCTS}
    >
      <div className='grid sm:grid-cols-2 gap-[20px] max-w-[1000px]'>
        <AnimatePresence mode='wait'>
          {loading &&
            Array.from(Array(2).keys()).map((t, i) => (
              <motion.div key={`trigger-list-card-skeleton-${i}`} {...motionFadeIn(0.2)}>
                <TriggerListCardSkeleton />
              </motion.div>
            ))}
          {!loading && data && data.length === 0 && (
            <motion.div key='no-triggers-create-button' {...motionFadeIn(0.2)}>
              <NoResultsAddCard
                message='Add a new device trigger.'
                disabled={loading || status === UNIT_STATUS_CANCELLED.value}
                callback={() => present()}
              />
            </motion.div>
          )}
          {!loading &&
            data &&
            data.length > 0 &&
            data.map((t, i) => (
              <motion.div key={`trigger-list-card-${i}`} {...motionFadeIn(0.2)}>
                <TriggerListCard unitStatus={status} unitId={unitId} productId={productId} trigger={t} />
              </motion.div>
            ))}
        </AnimatePresence>
      </div>
    </ProductNotSupportedCard>
  )
}
